import { Accordion } from '@chakra-ui/react';

export const Filters = (props) => {
  return <Accordion defaultIndex={0} {...props} />;
};
